export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 58 63" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="web端" transform="translate(-936.000000, -5335.000000)" stroke="#FFFFFF">
                    <g id="编组-15备份-2" transform="translate(936.000000, 5336.708031)">
                        <path
                            d="M21,18.3990596 L21,12.0322581 C21,9.25301868 23.3505051,7 26.25,7 L50.75,7 C53.6494949,7 56,9.25301868 56,12.0322581 L56,53.9677419 C56,56.7469813 53.6494949,59 50.75,59 L26.25,59 C23.3505051,59 21,56.7469813 21,53.9677419 L21,50.1405539"
                            id="路径"
                            strokeWidth="2.7"
                        ></path>
                        <path
                            d="M28,8 L28,7.74797902 L28,7.74797902 L28,5.05263158 C28,2.26214021 30.3903441,0 33.3389831,0 L43.6610169,0 C46.6096559,0 49,2.26214021 49,5.05263158 L49,7.53760357 L49,7.53760357 L49,8"
                            id="路径"
                            strokeWidth="2.7"
                        ></path>
                        <circle id="椭圆形" strokeWidth="2.7" cx="18" cy="34" r="16.65"></circle>
                        <rect id="矩形" fill="#FFFFFF" x="17" y="17.9618351" width="2" height="2.97895131" rx="1"></rect>
                        <rect id="矩形备份-2" fill="#FFFFFF" x="17" y="47.0609524" width="2" height="2.97895131" rx="1"></rect>
                        <rect
                            id="矩形"
                            fill="#FFFFFF"
                            transform="translate(32.549559, 34.000869) rotate(-270.000000) translate(-32.549559, -34.000869) "
                            x="31.5495586"
                            y="32.5113937"
                            width="2"
                            height="2.97895131"
                            rx="1"
                        ></rect>
                        <rect
                            id="矩形备份-2"
                            fill="#FFFFFF"
                            transform="translate(3.450441, 34.000869) rotate(-270.000000) translate(-3.450441, -34.000869) "
                            x="2.45044136"
                            y="32.5113937"
                            width="2"
                            height="2.97895131"
                            rx="1"
                        ></rect>
                    </g>
                </g>
            </g>
        </svg>
    );
}
